import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";

const DRIVER_DEVICE_ID_KEY = "driver_device_id";

function getOrCreateWebDeviceId() {
  try {
    const existing = localStorage.getItem(DRIVER_DEVICE_ID_KEY);
    if (existing) return existing;
    const generated = `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(DRIVER_DEVICE_ID_KEY, generated);
    return generated;
  } catch {
    return "web-device";
  }
}

export async function getDriverDeviceInfo() {
  if (!Capacitor.isNativePlatform()) {
    return {
      device_id: getOrCreateWebDeviceId(),
      device_name: window.navigator.userAgent,
      platform: "web",
      model: window.navigator.userAgent,
      operatingSystem: "web",
      operating_system: "web",
      isVirtual: false,
    };
  }
  const [info, idInfo] = await Promise.all([
    Device.getInfo(),
    Device.getId().catch(() => ({ identifier: "" })),
  ]);
  return {
    ...info,
    device_id: idInfo?.identifier || getOrCreateWebDeviceId(),
    device_name: [info.manufacturer, info.model].filter(Boolean).join(" ") || info.model || "iOS device",
    operating_system: info.operatingSystem || "",
  };
}
